import request from '../../../../../../../api/request';

const BASE = '/maintainers-portal/financial-portal/settings/cost-centers';

export interface CostCenterItem {
  id: number;
  name: string;
  code: string;
}

export interface CostCenterPayload {
  name: string;
  /** La API lo guarda en mayúsculas y lo exige único entre los vigentes. */
  code: string;
}

/** Cuerpo del 409 cuando el código ya está tomado por otro centro vigente. */
export interface CostCenterCodeTakenError {
  code: 'CODE_TAKEN';
}

export function getCostCenters() {
  return request<CostCenterItem[]>(BASE);
}

export function createCostCenter(body: CostCenterPayload) {
  return request<CostCenterItem>(BASE, { method: 'post', data: body });
}

export function updateCostCenter(id: number, body: CostCenterPayload) {
  return request<CostCenterItem>(`${BASE}/${id}`, {
    method: 'put',
    data: body,
  });
}

export function deleteCostCenter(id: number) {
  return request<void>(`${BASE}/${id}`, { method: 'delete' });
}
